/**
 * WebAuthn-PRF: der Passkey entsperrt den Schlüsselspeicher (ADR-004, SECURITY.md §3.5).
 *
 * Der geplante Hauptweg — Fingerabdruck auflegen, fertig, kein Passwort. Genau
 * das, was Anf. 75 („Kann eine technisch unerfahrene ältere Person das?")
 * verlangt.
 *
 * Der Authenticator liefert aus einem festen Eingabewert ein deterministisches
 * Geheimnis, das nie sein Gehäuse verlässt und nirgends gespeichert wird.
 * Verfügbar ist die Erweiterung nicht überall — deshalb bleibt der
 * Passphrase-Weg als Rückfallebene bestehen.
 */

/**
 * Fester Eingabewert. Er ist KEIN Geheimnis: Ohne den Authenticator nützt er
 * niemandem etwas. Er muss nur stabil bleiben — ändert er sich, ändert sich
 * das abgeleitete Geheimnis, und der Speicher lässt sich nicht mehr öffnen.
 */
const PRF_EINGABE = new TextEncoder().encode('family-hub/keystore/v1')

type PrfErgebnis = { prf?: { results?: { first?: ArrayBuffer }; enabled?: boolean } }

/** Erweiterungen, die bei der Anmeldung mitgeschickt werden. */
export function prfAnfordern(): Record<string, unknown> {
  return { prf: { eval: { first: PRF_EINGABE } } }
}

/**
 * Liest das Ergebnis aus einer WebAuthn-Antwort. `null` heißt: Dieser
 * Authenticator kann es nicht — dann greift der Passphrase-Weg.
 */
export function prfAuslesen(results: unknown): ArrayBuffer | null {
  const r = results as PrfErgebnis | undefined
  return r?.prf?.results?.first ?? null
}

/** Ob der Authenticator die Erweiterung überhaupt unterstützt. */
export function prfUnterstuetzt(results: unknown): boolean {
  const r = results as PrfErgebnis | undefined
  return r?.prf?.enabled === true || r?.prf?.results?.first !== undefined
}
